goog.provide('el8.ptdata.model.order');
goog.provide('el8.ptdata.model.baseOrder');
goog.provide('el8.ptdata.model.orderAncillary');
goog.provide('el8.ptdata.model.orderOtherAncillary');

goog.require('el8.model.base');
goog.require('el8.data.labOrderTests');
goog.require('el8.data.physicians');
goog.require('el8.data.referencedUsers');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.ptdata.model.letterAttachment');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.ptdata.documentReminders');
goog.require('el8.ptdata.documentReminder');
goog.require('el8.app.shared.dialog.collectCancelReason');
goog.require('el8.app.settings.genericOrder');

goog.require('el8.data.labOrderTests');

(function() {

    // ------------------
    // Define base order class
    // ------------------
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeHoldable();
    _class.makeDocument();

    _class.addIcd9s();
    _class.addIcd10s();

    _class.addProperty('icd9Descs', false); // for rendering report feeds faster
    _class.addProperty('icd10Descs', false);
    _class.addBoolean('showDualCoding', true);

    _class.addIntProperty("prescribingUserId", true);
    _class.addDateTime('createDate');

    _class.addIntProperty("orderSetId", true);

    _class.addStringProperty('orderType', false);
    var super_getOrderType = _class.prototype.getOrderType;
    _class.prototype.getOrderType = function() {
        // This makes sure getOrderType works for client-created orders
        var orderType = super_getOrderType.call(this);
        if (!orderType) {
            // i.e. 'lab', 'cardiac', 'imaging', 'pulmonary', 'sleep', 'referral'
            var modelClass = this.getModelClass();
            orderType =  modelClass.substring(0, modelClass.indexOf('Order')).toLowerCase();
        }
        return orderType;
    };

    // ------------------------------
    // Helpful methods for use in and out of feeds
    // ------------------------------
    _class.prototype.getNotifyText = function( type ) {
        switch( type ) {

            case 'SAVE_IN_PROGRESS':
                if( this.isOnHold() ) {
                    return 'Placing ' + this.getDescription().toLowerCase() + ' on hold...';
                } else {
                    return 'Saving ' + this.getDescription().toLowerCase() + '...';
                }
                break;

            case 'SAVE_COMPLETE':
                if( this.isOnHold() ) {
                    return this.getDescription() + ' placed on hold.';
                } else {
                    return this.getDescription() + ' filed in chart.';
                }
                break;

            case 'DELETE_IN_PROGRESS':
                return 'Discarding ' + this.getDescription().toLowerCase() + '...';

            case 'DELETE_COMPLETE':
                return this.getDescription() + ' discarded.';

            case 'ADD_TO_NOTE':
                return this.getDescription() + ' added to current note.';
        }
        return '';
    };
    _class.prototype.getDescription = function() {
        var retVal = this.getOrderType().capitalize() + ' Order';
        //
        //  Sleep to Generic order UI reskin
        //
        retVal = retVal === 'Sleep Order' ? el8.app.settings.genericOrder().getLabel('Order', 'Sleep Order') : retVal;

        if (this.getOrderType().localeCompare('lab') === 0) {
            retVal += ': ' + this.getVendorName();
        }
        return retVal;
    };


    // ------------------
    // Extend base class to ancillaries
    // ------------------
    var _classAncillary = function(spec) { this.populate(spec); };
    _classAncillary.inheritsFrom(_class);

    _classAncillary.addDate('dateForTest', true);
    _classAncillary.addStringProperty("followUpMethod", true);
    _classAncillary.addProperty('ccIds', true);
    _classAncillary.addProperty('ccNames', true);

    _classAncillary.addStringProperty('testCenterName');
    _classAncillary.addIntProperty('testCenterCompanyId', true);
    _classAncillary.addStringProperty('testCenterCompanyName');

    _classAncillary.addStringProperty('testCenterAddressLine');
    _classAncillary.addStringProperty('testCenterCityStateZip');
    _classAncillary.addStringProperty('testCenterPhone');
    _classAncillary.addStringProperty('testCenterFax');
    _classAncillary.addIntProperty('testCenterSiteId', true);

    _classAncillary.addStringProperty('patientInstructions', true);
    _classAncillary.addStringProperty('testCenterNotes', true);

    // Labs don't send down these keys anymore, they send down the entire test's
    // json instead and these are populated from that spec for compatibility
    _classAncillary.addProperty('testIds', true);
    _classAncillary.addProperty('testNames', true);

    // Properties for order status: e.g. 'outstanding', 'cancelled', or 'fulfilled'
    // orthogonal to any reminders or notifications
    _classAncillary.addStringProperty('currentState', true);
    _classAncillary.addStringProperty('currentStateNote', true);
    _classAncillary.addIntProperty('currentStateResolvingDocumentId', true);
    _classAncillary.addDateTime('currentStateTime', true);

    // The latest active reminder id
    _classAncillary.addModelProperty('reminder', el8.ptdata.documentReminder, true);

    // Note: we use these when submitting orders, when fetching them we fetch the associated
    // reminder via the id above and populate the reminder in the soymap
    _classAncillary.addIntProperty('reminderUserId', true);
    _classAncillary.addIntProperty('reminderGroupId', true);
    _classAncillary.addDate('reminderDate', true);

    _classAncillary.prototype.asSoyMap = function() {
        var mapped = _class.prototype.asSoyMap.call(this);
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        if (this.getReminder()) {
            mapped['reminder'] = this.getReminder().asSoyMap(true); // without order
        }
        return mapped;
    };


    // ------------------------------
    // Helpful methods for use in and out of feeds
    // ------------------------------
    _classAncillary.prototype.getPatientSummary = function() {
        // don't forget this is escaped!
        return el8.template.ptdata.model.order.orderPatientSummary({order: this.asSoyMap()});
    };
    _classAncillary.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.order.orderNoteSummary(this.asSoyMap()).el8_unescape();
    };
    _classAncillary.prototype.getNoteOwnedDocSummary = function(forServer) {
        /**
         * When order is owned by note:
         *   - If forServer=true, return the (string, formatting) pair that needs
         *     to get sent to the server
         *    - Else, return the HTML summary
         */
        var soyMap = this.asSoyMap();
        var tagStr = el8.template.ptdata.model.order.ownedDocSummaryTag(soyMap).el8_unescape();
        var summaryStr = tagStr + el8.template.ptdata.model.order.ownedDocSummaryDescription(soyMap).el8_unescape();
        var result = {
            summary: summaryStr,
            summary_formatting: [{"decoration": "tag_item", "offsets": [0, tagStr.length]}]
        };
        return forServer ? result :
            el8.util.format(result['summary'], result['summary_formatting']);
    };

    //
    // Helpers for state and reminders
    //
    _classAncillary.prototype.fulfill = function(opts) {
        var doc = this;
        var opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('fulfillDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({
                reason: opts.reason ? opts.reason : null,
                resolving_document_id: opts.resolvingDocumentId ? opts.resolvingDocumentId : null
            }),
            success: function (data) {
                var entitySet = el8.ptdata.getEntitySet(data.model_class);
                entitySet.create(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };
    _classAncillary.prototype.cancel = function(opts) {
        var doc = this;
        var opts = opts || {};
        el8.app.shared.dialog.collectCancelReason.show({
            saveCallbackFn: function(obj) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('cancelDocument', [doc.getPatientId(), doc.getId()]),
                    data: JSON.stringify({reason: obj.reason ? obj.reason : null}),
                    success: function (data) {
                        var entitySet = el8.ptdata.getEntitySet(data.model_class);
                        entitySet.create(data);
                        if (opts.successCb) { opts.successCb(); }
                    }
                });
            }
        });
    };

    _classAncillary.prototype.outstanding = function(opts) {
        var doc = this;
        var opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('outstandingDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({reason: opts.reason ? opts.reason : null}),
            success: function (data) {
                var entitySet = el8.ptdata.getEntitySet(data.model_class);
                entitySet.create(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };


    // -------------------------
    // Extend to other ancillaries
    // -------------------------
    var _classOtherAncillary = function(spec) { this.populate(spec); };
    _classOtherAncillary.inheritsFrom(_classAncillary);

    _classOtherAncillary.addStringProperty('clinicalReason', true);

    // TODO Don't really need to expose these, but if remove, have to change tests
    el8.ptdata.model.baseOrder = function(spec) { return new _class(spec); };
    el8.ptdata.model.orderAncillary = function(spec) { return new _classAncillary(spec); };
    el8.ptdata.model.orderOtherAncillary = function(spec) { return new _classOtherAncillary(spec); };

    el8.ptdata.model.order.sleep = function(spec) { return new _classOtherAncillary(spec); };

    // --------------------------
    // PULMONARY ORDER
    // --------------------------
    var _classPulmonary = function(spec) { this.populate(spec); };
    _classPulmonary.inheritsFrom(_classOtherAncillary);
    _classPulmonary.addStringProperty('allergies', true);

    el8.ptdata.model.order.pulmonary = function(spec) { return new _classPulmonary(spec); };

    // ----------------------------
    // CARDIAC ORDER
    // ----------------------------
    var _classCardiac = function(spec) { this.populate(spec); };
    _classCardiac.inheritsFrom(_classOtherAncillary);
    _classCardiac.addStringProperty('medications', true);

    el8.ptdata.model.order.cardiac= function(spec) { return new _classCardiac(spec); };


    // ----------------------------
    // IMAGING ORDER
    // ----------------------------
    var _classImaging = function(spec) { this.populate(spec); };
    _classImaging.inheritsFrom(_classOtherAncillary);
    _classImaging.addStringProperty('statMethod', true);
    _classImaging.addStringProperty('displayStatMethod');

    el8.ptdata.model.order.imaging= function(spec) { return new _classImaging(spec); };


    // --------------------------
    // LAB ORDER
    // --------------------------
    var _classLab = function(spec) { this.populate(spec); };


    _classLab.inheritsFrom(_classAncillary);

    _classLab.addStringProperty('billType', true);
    _classLab.addStringProperty('displayBillType', true);

    _classLab.addStringProperty('statMethod', true);
    _classLab.addStringProperty('displayStatMethod');

    _classLab.addStringProperty('fastingMethod', true);
    _classLab.addStringProperty('displayFastingMethod');

    _classLab.addStringProperty('standingOrderFrequency', true);
    _classLab.addDate('standingOrderEndDate', true); // DATE

    // electronic submission
    _classLab.addBoolean('sendToLabEnabled', false, false);
    _classLab.addStringProperty('submissionState', false, null);
    _classLab.addDateTime('submissionTime', false, null);

    // We added these to the LabOrder model, deprecating the testCenter* stuff from the parent
    _classLab.addIntProperty('vendorId', true);
    _classLab.addIntProperty('siteId', true);
    _classLab.addBoolean('isInHouse', false);

    // Shipping up the whole test here so we can send up AOE answers attached naturally to AOE questions
    _classLab.addModelSetProperty('answers', el8.data.labOrderTests.AOEAnswer, true, []);
    _classLab.addModelSetProperty('tests', el8.data.labOrderTests._model, true, []);
    _classLab.addDateTime('collectionDatetime', true, null);
    _classLab.addStringProperty('specialInsuranceName', true);
    _classLab.addStringProperty('specialInsuranceCode', true);
    _classLab.addStringProperty('vendorName', true);
    _classLab.addStringProperty('requisitionId', true);

    // add LabOrderToFacility model for e-ordering
    _classLab.addIntProperty('facilityId', true);
    // special insurance gets passed as JSON, so we'll manually set it at populate
    _classLab.addProperty('specialInsuranceCode', true);
    _classLab.addProperty('specialInsuranceName', true);

    // Specimen collection data
    _classLab.addProperty('specimenCollectedBy', true); // set at populate

    _classLab.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.tests) {
            spec.testIds = spec.tests.map(function(a) { return a.id; });
            spec.testNames = spec.tests.map(function(a) { return a.name; });
            el8.data.labOrderTests.create(spec.tests);
        }
        // if special insurance exists for order, prep it for parent populate call
        if (spec.special_insurance) {
            spec.specialInsuranceName = spec.special_insurance.name;
            spec.specialInsuranceCode = spec.special_insurance.code;
        }
        var specimenCollections = spec.specimen_collections;
        if (specimenCollections && specimenCollections.length > 0) {
          // Use the first collection record's data to get the name of the staff
          // member that originally documented the specimen collection datetime
          var updatedByUserId = specimenCollections[0].updated_by.id;
          var collectedByUser = el8.data.practiceUsers.getById(updatedByUserId)
          spec.specimenCollectedBy = collectedByUser ? collectedByUser.getFullName() : null;
        }
        this.parent.populate.call(this, spec);
    };

    el8.ptdata.model.order.lab = function(spec) {
        return new _classLab(spec);
    };

    /**
     * Helper methods
     */
    _classLab.prototype.updateCollectionDatetime = function(collectionDatetime) {
      var labOrder = this;
      labOrder.setCollectionDatetime(collectionDatetime || null);
      var entitySet = el8.ptdata.getEntitySet(labOrder.getModelClass());
      entitySet.refreshById(labOrder.getId());
    }


    // --------------------------
    // REFERRAL ORDER
    // --------------------------
    var _classReferral = function(spec) { this.populate(spec); };
    _classReferral.inheritsFrom(_class);

    _classReferral.addStringProperty( 'clinicalReason');
    _classReferral.addIntProperty('physicianId');

    _classReferral.addDate('dateForReEval');
    _classReferral.addStringProperty('authorizationFor', true); // the Choices 'value'
    _classReferral.addStringProperty('authorizationForShort', true); // the Choices 'key'
    _classReferral.addStringProperty('authNumber', true);

    // attachment set
	_class.addModelSetProperty('attachments', el8.ptdata.model.letterAttachment, true, []);

    _classReferral.addStringProperty('consultantName');
    _classReferral.addStringProperty('shortConsultantName');

    _classReferral.addIntProperty('specialtyId');
    _classReferral.addStringProperty('specialtyName');
    _classReferral.addStringProperty('specialtyAbbreviation');

    // These are used only for new orders - temporary info
    _classReferral.addStringProperty('manualConsultantName');

    // Properties for order status: e.g. 'outstanding', 'cancelled', or 'fulfilled'
    // orthogonal to any reminders or notifications
    _classReferral.addStringProperty('currentState', true);
    _classReferral.addStringProperty('currentStateNote', true);
    _classReferral.addIntProperty('currentStateResolvingDocumentId', true);
    _classReferral.addDateTime('currentStateTime', true);

    // The latest active reminder id
    _classReferral.addModelProperty('reminder', el8.ptdata.documentReminder, true);

    // Note: we use these when submitting orders, when fetching them we fetch the associated
    // reminder via the id above and populate the reminder in the soymap
    _classReferral.addIntProperty('reminderUserId', true);
    _classReferral.addIntProperty('reminderGroupId', true);
    _classReferral.addDate('reminderDate', true);

    _classReferral.prototype.asSoyMap = function() {
        var mapped = _class.prototype.asSoyMap.call(this);
        delete mapped['manualConsultantName'];
        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();
        mapped['signDate'] = this.getSignDate() ? el8.service.tz.soyStr(this.getSignDate()) : '';
        mapped['attachments'] = this.getAttachments().map(el8.model.toSoyMapFn);
        mapped['icd9CodeObjs'] = this.getIcd9CodeObjs().map(el8.model.toSoyMapFn);
        mapped['icd10CodeObjs'] = this.getIcd10CodeObjs().map(el8.model.toSoyMapFn);
        if (this.getReminder()) {
            mapped['reminder'] = this.getReminder().asSoyMap(true); // without order
        }
        return mapped;
    };

    /**
     * call the server to create a new order and get back a letter
     */
    _classReferral.prototype.reOrderWithLetter = function(opts) {
        opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('referralOrderReOrderWithLetter', [this]),
            data: {},
            success: function(data) {
                var updatedLetter = el8.ptdata.letters.create(data);
                if (opts.successCb) { opts.successCb(updatedLetter); }
            }
        });
    };



    /**
     * HELPER METHODS
     */
    _classReferral.prototype.getPhysician = function() {
        var physicianId = this.getPhysicianId();
        return physicianId ? el8.data.physicians.getById(physicianId) : null;
    };
    _classReferral.prototype.getDescription = function() {
        return 'Referral';
    };
    _classReferral.prototype.asMap = function(underscore, prefixBools) {
        var m = this.parent.asMap.call(this, underscore, prefixBools);
        if (!this.getPhysicianId() && this.getManualConsultantName()) {
            var keyName = underscore ? 'consultant_name' : 'consultantName';
            m[keyName] = this.getManualConsultantName();
        }
        return m;
    };

    // ---------------------------
    // Useful helper methods
    // ---------------------------

    //
    // Helpers for state and reminders
    //
    _classReferral.prototype.fulfill = function(opts) {
        var doc = this;
        var opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('fulfillDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({
                reason: opts.reason ? opts.reason : null,
                resolving_document_id: opts.resolvingDocumentId ? opts.resolvingDocumentId : null
            }),
            success: function (data) {
                var entitySet = el8.ptdata.getEntitySet(data.model_class);
                entitySet.create(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };
    _classReferral.prototype.cancel = function(opts) {
        var doc = this;
        var opts = opts || {};
        el8.app.shared.dialog.collectCancelReason.show({
            saveCallbackFn: function(obj) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('cancelDocument', [doc.getPatientId(), doc.getId()]),
                    data: JSON.stringify({reason: obj.reason ? obj.reason : null}),
                    success: function (data) {
                        var entitySet = el8.ptdata.getEntitySet(data.model_class);
                        entitySet.create(data);
                        if (opts.successCb) { opts.successCb(); }
                    }
                });
            }
        });
    };

    _classReferral.prototype.outstanding = function(opts) {
        var doc = this;
        var opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('outstandingDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({reason: opts.reason ? opts.reason : null}),
            success: function (data) {
                var entitySet = el8.ptdata.getEntitySet(data.model_class);
                entitySet.create(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    _classReferral.prototype.getPatientSummary = function() {
        // don't forget this is escaped!
        return el8.template.ptdata.model.order.referral.patientSummary(this.asSoyMap());
    };

    _classReferral.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.order.referral.noteSummary(this.asSoyMap()).el8_unescape();
    };

    _classReferral.prototype.getNoteOwnedDocSummary = function(forServer) {
        /**
         * When referral is owned by note:
         *   - If forServer=true, return the (string, formatting) pair that needs
         *     to get sent to the server
         *    - Else, return the HTML summary
         */
        var soyMap = this.asSoyMap();
        var tagStr = el8.template.ptdata.model.order.referral.ownedDocSummaryTag(soyMap).el8_unescape();
        var reasonStr = el8.template.ptdata.model.order.referral.ownedDocSummaryReason(soyMap).el8_unescape();
        var summaryStr = tagStr +
            el8.template.ptdata.model.order.referral.ownedDocSummaryConsultant(soyMap).el8_unescape()
            + reasonStr;
        var formatting = [
            {"decoration": "tag_item", "offsets": [0, tagStr.length]}
        ];
        if (reasonStr) {
            var reasonStrStart = summaryStr.indexOf(reasonStr);
            formatting.push(
                {"decoration": "left_indent", "offsets": [reasonStrStart, reasonStrStart + reasonStr.length]}
            );
        }
        var result = {
            summary: summaryStr,
            summary_formatting: formatting
        };
        return forServer ? result :
            el8.util.format(result['summary'], result['summary_formatting']);
    };

    el8.ptdata.model.order.referral = function(spec) { return new _classReferral(spec); };

})();
